import React, { createContext, PropsWithChildren, useState } from 'react';
import PhoneBillDialog from '@/components/PhoneBillDialog';

type PhoneBillDialogContextProps = {
  open: () => void;
  close: () => void;
};

const PhoneBillDialogContext =
  createContext<PhoneBillDialogContextProps | null>(null);
PhoneBillDialogContext.displayName = 'PhoneBillDialog';

const PhoneBillDialogProvider = ({ children }: PropsWithChildren) => {
  const [isOpen, setIsOpen] = useState(false);

  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  return (
    <PhoneBillDialogContext.Provider value={{ open, close }}>
      {children}
      <PhoneBillDialog open={isOpen} handleClose={close} />
    </PhoneBillDialogContext.Provider>
  );
};

export { PhoneBillDialogProvider, PhoneBillDialogContext };
